import React, { useState, useEffect, useRef } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, isNumeric, validateButtonASIBlock, getStatusFlagValue, generateRandomNumber, isHqAsiAdminRole } from '../../Custom/Custom';
import BlockHJsonData from '../../assets/BlockHData.json';
import asiTitle from '../../asi.json';


export default function BlockH({
  blockPageInfo,
  config,
  userInfoObject,
  blockInfo,
  accessAsiBlock,
  decode_token
}) {

  const [itemData, setItemData] = useState({});
  const [originalValues, setOriginalValues] = useState({}); // Add this state to track original values
  const [blockHData, setBlockHData] = useState({});
  const navigate = useNavigate();
  const yearRange = generateYearRange(blockInfo.surveyYear);
  const [buttonStatus, setButtonStatus] = useState('');
  const [statusFlageval, setstatusFlageval] = useState('');
  const [checkedItems, setCheckedItems] = useState([]);
  const dtableRef = useRef(null);
  const statusUnitCode = localStorage.getItem('statusUnitCode')
  const itemCodeArray = ['9920100', '9990100', '9920300', '9990800', '9990400'
    , '9990500', '9990600', '9990700', '9990900', '9920400', '9922000', '9992000', '9993000',
    '9999900']

  const userLevel = decode_token?.id?.USER_TYPE || '';
  const roleCodes = decode_token?.id?.ROLE_CODE
    ? decode_token.id.ROLE_CODE.split('|').map((r) => String(r).trim())
    : [];
  const isDivasiRole = roleCodes.includes('DIVASI');
  const isDivasiStatusFlagOne = isDivasiRole && String(statusFlageval ?? '').trim() === '1';
  const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
  const isHqStatusFlagThree = isHqRole && String(statusFlageval ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(statusFlageval ?? '').trim() === '';
  const isNextBlockAlreadyAccessible = (() => {
    const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
    return Array.isArray(ids) && ids.map(Number).includes(9);
  })();

  /** Pehli kuch rows (blanks) par statusFlag empty hota hai; unit-level flag DB rows / last static rows par. */
  const pickBlockHStatusFlag = (rows) => {
    if (!Array.isArray(rows) || rows.length === 0) return '';
    for (let i = rows.length - 1; i >= 0; i--) {
      const sf = rows[i]?.statusFlag;
      const s = sf == null ? '' : String(sf).trim();
      if (s !== '') return s;
    }
    return '';
  };

  // Save/Next: workflow overrides (Block M / L jaisa — validateButtonASIBlock ke saath)
  useEffect(() => {
    let duser = 0;
    if (userLevel === 'DIVISION LEVEL') {
      if (statusFlageval === "3" || statusFlageval === "7" || statusFlageval === "8")
        duser = 1;
    }
    if (statusFlageval === "4" || statusFlageval === "9") {
      const rejectBtn = document.getElementById("reject");
      if (rejectBtn) rejectBtn.disabled = true;
    }
    if (userLevel === 'HEAD QUARTER') {
      if (statusFlageval === "2" || statusFlageval === "6") duser = 1;
      if (statusFlageval === "3") duser = 2;
    }
    if (duser === 2 && userLevel === 'HEAD QUARTER') {
      if (!(statusFlageval === "3" && isHqAsiAdminRole(roleCodes))) {
        const saveBtn = document.getElementById("save");
        if (saveBtn) saveBtn.disabled = true;
      }
    }
    if (duser === 1) {
      const saveBtn = document.getElementById("save");
      if (saveBtn) saveBtn.disabled = true;
      if (userLevel === 'DIVISION LEVEL') {
        const submitBtn = document.getElementById("submit");
        if (submitBtn) submitBtn.disabled = true;
        const rejectBtnDiv = document.getElementById("reject");
        if (rejectBtnDiv) rejectBtnDiv.disabled = true;
      }
      if (userLevel === 'HEAD QUARTER') {
        const acceptBtn = document.getElementById("accept");
        const rejectBtn = document.getElementById("reject");
        if (acceptBtn) acceptBtn.disabled = true;
        if (rejectBtn) rejectBtn.disabled = true;
      }
    }
  }, [userLevel, statusFlageval]);

  useEffect(() => {
    blockHDataLoad();
  }, [])

  // Function to handle page load fromdata
  const blockHDataLoad = async () => {
    const newObject = {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
    };
    showAppLoading(true)
    try {
      const response = await axios.post(`${API_URL}api/asi/blockHForm`, newObject, config);
      const { data, status } = response.data;

      let responseBlockHData = '';
      let statusFlage = '';

      if (status) {
        data.blockHData.sort((a, b) => {
          const indexA = itemCodeArray.indexOf(a.itemCode);
          const indexB = itemCodeArray.indexOf(b.itemCode);
          return indexA - indexB;
        });
        let numofblankrow = 24 - data.blockHData.length;
        responseBlockHData = addNineEmptyRow(data.blockHData, 'dynamic', numofblankrow - 1); //  Database
        statusFlage = pickBlockHStatusFlag(responseBlockHData);
      } else {
        responseBlockHData = addNineEmptyRow(BlockHJsonData, 'static', 9);// static  json Data
        statusFlage = ''
      }

      setstatusFlageval(String(statusFlage ?? '').trim());

      const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
      customObjectObjectData(responseBlockHData)
      setButtonStatus(IsButtonStatus)
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showAppLoading(false);
    }

  }

  // Function to handle update state on change event
  const handleOnChange = (IndexId, field, newValue) => {
    if (!isNumeric(newValue)) {
      toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
      newValue = '';
    }

    // Track original value for itemCode field when user first starts typing
    if (field === 'itemCode' && !originalValues[IndexId]) {
      const currentValue = itemData[IndexId] ? itemData[IndexId].itemCode : '';
      setOriginalValues(prev => ({
        ...prev,
        [IndexId]: currentValue
      }));
    }

    setItemData(prevItemData => {
      const updatedItemData = {
        ...prevItemData,
        [IndexId]: {
          ...prevItemData[IndexId],
          [field]: newValue
        }
      };

      // Auto-calculate Rate per Unit when Quantity Consumed or Purchase Value changes
      // Only calculate if Rate per Unit field is not disabled for this itemCode
      const disabledItemCodes = ['9920100', '9920300', '9920400', '9922000', '9990100',
        '9990400', '9990600', '9990700', '9990800', '9990900', '9992000', '9993000', '9999900'];
      const isRatePerUnitDisabled = disabledItemCodes.includes(updatedItemData[IndexId]?.itemCode);
      
      if ((field === 'qtyConsumed' || field === 'purchaseValue') && !isRatePerUnitDisabled) {
        const qtyConsumed = field === 'qtyConsumed' ? newValue : (updatedItemData[IndexId]?.qtyConsumed || '');
        const purchaseValue = field === 'purchaseValue' ? newValue : (updatedItemData[IndexId]?.purchaseValue || '');
        
        // Check if both values are valid numbers and greater than 0
        const qtyNum = parseFloat(qtyConsumed);
        const purchaseNum = parseFloat(purchaseValue);
        
        if (!isNaN(qtyNum) && !isNaN(purchaseNum) && qtyNum > 0 && purchaseNum > 0) {
          const calculatedRate = purchaseNum / qtyNum;
          // Round to 2 decimal places
          updatedItemData[IndexId].ratePerUnit = calculatedRate.toFixed(2);
        } else {
          // If either value is empty or invalid, clear rate per unit
          updatedItemData[IndexId].ratePerUnit = '';
        }
      }

      return updatedItemData;
    });


  }

  // Function to handle focus event - store original value when user first focuses on itemCode field
  const handleOnFocus = (IndexId, field) => {
    if (field === 'itemCode' && !originalValues[IndexId]) {
      const currentValue = itemData[IndexId] ? itemData[IndexId].itemCode : '';
      console.log('Storing original value for IndexId:', IndexId, 'Value:', currentValue);
      setOriginalValues(prev => ({
        ...prev,
        [IndexId]: currentValue
      }));
    }
  }


  const handleOnBlur = async (IndexId, newValue) => {

    // Check if value has actually changed
    const originalValue = originalValues[IndexId] || '';

    console.log('handleOnBlur - IndexId:', IndexId, 'Original Value:', originalValue, 'New Value:', newValue);

    // If value hasn't changed, don't make API call
    if (originalValue === newValue) {
      console.log('Value unchanged, skipping API call for IndexId:', IndexId);
      // Clear the original value tracking for this field
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
      return false;
    }

    let newItemAdded = {
      "id": IndexId,
      "dslNo": blockInfo.dslNo,
      "surveyYear": blockInfo.surveyYear,
      "itemDesc": "",
      "itemCode": "",
      "unitOfQty": "",
      "qtyConsumed": "",
      "purchaseValue": "",
      "ratePerUnit": "",
      "statusFlag": "",
      "saveOrderBy": 1,
      "itemCodeClass": "textBox_back_color_white",
    };

    if (newValue === '') {
      newItemAdded.itemCode = "";
      handleTableRowData(IndexId, newItemAdded)
      // Clear original value tracking
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
      return false;
    }
    const asicc_code = newValue
    const newObject = {
      asicc_code: asicc_code

    };

    if (asicc_code.length < 7) {
      newItemAdded.itemCode = "";
      handleTableRowData(IndexId, newItemAdded)
      toast.error("Invalid NPCMS Code.", messages.COLOR_RED);
      // Clear original value tracking
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
      return false;
    }
    showAppLoading(true);
    try {
      const response = await axios.post(`${API_URL}api/asi/blockHFetchDataByItemCodeNPCMS`, newObject, config);
      const { data, status } = response.data;

      if (status) {
        const response = data.blockHData;
        newItemAdded = {
          "id": IndexId,
          "dslNo": blockInfo.dslNo,
          "surveyYear": blockInfo.surveyYear,
          "itemDesc": response.itemName,
          "itemCode": asicc_code,
          "unitOfQty": response.unitOfQuantity,
          "qtyConsumed": "",
          "purchaseValue": "",
          "ratePerUnit": "",
          "statusFlag": "",
          "saveOrderBy": 1,
          "itemCodeClass": "textBox_back_color_white",
        };
      } else {

        newItemAdded = {
          "id": IndexId,
          "dslNo": blockInfo.dslNo,
          "surveyYear": blockInfo.surveyYear,
          "itemDesc": '',
          "itemCode": '',
          "unitOfQty": '',
          "qtyConsumed": "",
          "purchaseValue": "",
          "ratePerUnit": "",
          "statusFlag": "",
          "saveOrderBy": 1,
          "itemCodeClass": "textBox_back_color_white",
        };
        toast.error('Item not present - Please check itemcode', messages.COLOR_RED);

      }
      handleTableRowData(IndexId, newItemAdded)


    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showAppLoading(false);
      // Clear original value tracking in all exit points (success, error, early return)
      setOriginalValues(prev => {
        const newState = { ...prev };
        delete newState[IndexId];
        return newState;
      });
    }
  }


  const handleTableRowData = (IndexId, newItemAdded) => {
    setItemData(prevItemData => ({
      ...prevItemData,
      [IndexId]: {
        ...prevItemData[IndexId],
        ...newItemAdded
      }
    }));
    return true;
  }

  // Function to handle Added 9 empty row on page Load  
  const addNineEmptyRow = (responseBlockHData, dataType, emptyRowCount) => {
    let customObject = [];
    let mergedArray = '';
    for (let i = 0; i <= emptyRowCount; i++) {
      const newItemAdded = {
        "dslNo": blockInfo.dslNo,
        "surveyYear": blockInfo.surveyYear,
        "itemDesc": "",
        "itemCode": "",
        "unitOfQty": "",
        "qtyConsumed": "",
        "purchaseValue": "",
        "ratePerUnit": "",
        "statusFlag": "",
        "saveOrderBy": 1,
        "itemCodeClass": "textBox_back_color_white",
      };
      customObject.push(newItemAdded);
    }

    if (dataType === "dynamic") {
      // Find the index where static items (itemCodeArray items) start
      // After sorting, static items (itemCodeArray) come after user entries
      const dataArray = Object.values(responseBlockHData);
      let AddedIndex = dataArray.length;
      
      // Find first occurrence of any static itemCode (itemCodeArray)
      // Since data is already sorted, first static item marks the start of static items
      for (let i = 0; i < dataArray.length; i++) {
        if (itemCodeArray.includes(dataArray[i].itemCode)) {
          AddedIndex = i;
          break;
        }
      }
      
      // Ensure we don't create duplicates - only insert blank rows before static items
      // If all items are static, insert at the beginning
      if (AddedIndex === dataArray.length) {
        AddedIndex = 0;
      }
      
      mergedArray = [
        ...responseBlockHData.slice(0, AddedIndex),
        ...customObject,
        ...responseBlockHData.slice(AddedIndex)
      ];
    } else if (dataType === "static") {
      mergedArray = [
        ...responseBlockHData.slice(0, 0),
        ...customObject,
        ...responseBlockHData.slice(0)
      ];
    }


    return mergedArray;
  };


  // Function to handle Added one row on button click
  const addRow = () => {
    let newCustomObject = [];
    for (let i = 0; i < 1; i++) {
      const newItemAdded = {
        "dslNo": blockInfo.dslNo,
        "surveyYear": blockInfo.surveyYear,
        "itemDesc": "",
        "itemCode": "",
        "unitOfQty": "",
        "qtyConsumed": "",
        "purchaseValue": "",
        "ratePerUnit": "",
        "statusFlag": "",
        "saveOrderBy": 1,
        "itemCodeClass": "textBox_back_color_white",
      };
      newCustomObject.push(newItemAdded);
    }
    const dataArray = Object.values(itemData);
    const AddedIndex = dataArray.length - 14
    dataArray.splice(AddedIndex, 0, ...newCustomObject);
    customObjectObjectData(dataArray)
  };


  // Item codes for which Rate per Unit is not auto-calculated (same as in handleOnChange)
  const RATE_PER_UNIT_DISABLED_ITEM_CODES = ['9920100', '9920300', '9920400', '9922000', '9990100',
    '9990400', '9990600', '9990700', '9990800', '9990900', '9992000', '9993000', '9999900'];

  // Function to handle update state according to data
  // When API returns only qtyConsumed & purchaseValue (no ratePerUnit), auto-calculate ratePerUnit for display
  const customObjectObjectData = (responseBlockHData) => {
    const initialData = {};
    responseBlockHData.forEach((item, index) => {
      let ratePerUnit = item.ratePerUnit;
      const hasRate = ratePerUnit !== undefined && ratePerUnit !== null && String(ratePerUnit).trim() !== '';
      const qtyConsumed = item.qtyConsumed;
      const purchaseValue = item.purchaseValue;
      const qtyNum = parseFloat(qtyConsumed);
      const purchaseNum = parseFloat(purchaseValue);
      const isRateDisabled = item.itemCode && RATE_PER_UNIT_DISABLED_ITEM_CODES.includes(String(item.itemCode).trim());
      if (!hasRate && !isRateDisabled && !isNaN(qtyNum) && !isNaN(purchaseNum) && qtyNum > 0 && purchaseNum > 0) {
        ratePerUnit = (purchaseNum / qtyNum).toFixed(2);
      }
      initialData[index] = {
        id: index,
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        itemDesc: item.itemDesc,
        itemCode: item.itemCode,
        unitOfQty: item.unitOfQty,
        qtyConsumed: item.qtyConsumed,
        purchaseValue: item.purchaseValue,
        ratePerUnit: ratePerUnit ?? item.ratePerUnit ?? '',
        statusFlag: item.statusFlag,
        saveOrderBy: item.saveOrderBy,
        itemCodeClass: item.itemCodeClass

      };
    });

    setItemData(initialData);
  }

  const handleCheckboxChange = (event, index) => {
    if (event.target.checked) {
      setCheckedItems([...checkedItems, index]);
    } else {
      setCheckedItems(checkedItems.filter((item) => item !== index));
    }
  };

  // Function to handle delete row
  const DeleteRow = () => {
    const dataArray = Object.values(itemData);

    if (checkedItems.length === 0) {
      toast.error('Please select at least one row for deletion.', messages.COLOR_RED);
      return false;
    }

    const updatedItems = dataArray.filter((_, index) => !checkedItems.includes(index));
    customObjectObjectData(updatedItems)
    setCheckedItems([]);
  };


  // Function to handle reset Form Data
  const handleReset = () => {
    const initialData = {};
    const dataArray = Object.values(itemData);
    dataArray.forEach((item, index) => {
      initialData[index] = {
        id: index,
        dslNo: blockInfo.dslNo,
        surveyYear: blockInfo.surveyYear,
        itemDesc: item.itemDesc,
        itemCode: item.itemCode,
        unitOfQty: '',
        qtyConsumed: '',
        purchaseValue: '',
        ratePerUnit: '',
        statusFlag: '',
        saveOrderBy: '',
        itemCodeClass: 'textBox_back_color_white'

      };
    });

    setItemData(initialData);
  }

  // Function to handle going to the previous block 
  const handlePrevious = () => {
    const confirmed = window.confirm("Have you saved your changes?");
    if (confirmed) {
      navigate("/BlockG")
    }
  }

  // Function to handle going to the next block      
  const handleNext = async () => {
    // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
    if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
      navigate("/BlockI");
      return;
    }
    // DIVASI + statusFlag=1: do not save, just navigate
    if (isDivasiStatusFlagOne) {
      navigate("/BlockI");
      return;
    }
    // HQADM/HQASI + statusFlag=3: do not save, just navigate
    if (isHqStatusFlagThree) {
      navigate("/BlockI");
      return;
    }
    // First check validation - show validation message if fails
    const validationPassed = valForBlockH();
    
    // If validation fails, show message and return (don't show "Have you saved your changes?" dialog)
    if (!validationPassed) {
      return false;
    }
    
    // If validation passes, then show "Have you saved your changes?" dialog
    const confirmed = window.confirm("Have you saved your changes?");
    if (confirmed) {
      if (statusUnitCode === '5') {
        // For FACTORY LEVEL users, try to save but navigate even if save fails
        const saveResult = await handleSaveData("SAVE");
        if (saveResult) {
          await blockValidation();
          navigate("/BlockI");
        } else {
          // Even if save fails, allow navigation for FACTORY LEVEL users
          await blockValidation();
          navigate("/BlockI");
        }
      } else {
        const saveResult = await handleSaveData("SAVE");
        if (saveResult) {
          await blockValidation();
          navigate("/BlockI");
        }
      }
    }
  }



  //All block validation Data
  const blockValidation = async () => {

    let postData = {
      dsl_no: blockInfo.dslNo,
      survey_year: blockInfo.surveyYear
    }

    try {
      showAppLoading(true);
      const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
      const { data, status } = response.data;
      const accessIds = data.allblockData
      if (accessIds.length > 0) {

        if (accessIds.length > [1, 2, 3, 4, 5, 6, 7, 8, 9].length) {
          accessAsiBlock(accessIds)
        } else {
          accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9])
        }

      } else {
        accessAsiBlock([1, 2, 3, 4, 5, 6, 7, 8, 9])
      }
      showAppLoading(false);
      return true;

    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {

    }

  }



  const handleValue = (value) => {
    return (value !== "" && value !== null && value !== undefined) ? value : 0;
  };

  // Function to handle update and save form data
  const handleSaveData = async (buttonType) => {

    if (statusUnitCode !== '5' && !valForBlockH()) {
      return false;
    }


    let allObjectData = itemData;

    let customItemCodes = [];
    const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel);

    for (let id in allObjectData) {
      // Check if itemCode exists and has a value
      if (allObjectData[id].itemCode) {
        const customObject = {
          dslNo: allObjectData[id].dslNo,
          surveyYear: allObjectData[id].surveyYear,
          srno: 0,
          itemCode: allObjectData[id].itemCode,
          itemDesc: allObjectData[id].itemDesc,
          unitOfQty: allObjectData[id].unitOfQty,
          qtyConsumed: handleValue(allObjectData[id].qtyConsumed),
          purchaseValue: handleValue(allObjectData[id].purchaseValue),
          ratePerUnit: handleValue(allObjectData[id].ratePerUnit),
          saveOrderBy: customItemCodes.length + 1,
          statusFlag: clickButtonStatusFlag
        };
        customItemCodes.push(customObject);
      }
    }

    const newObject = {
      itemCodes: customItemCodes,
      payload: {
        dsl_no: blockInfo.dslNo,
        survey_year: blockInfo.surveyYear,
        buttonType: buttonType
      }
    }


    showAppLoading(true);

    try {
      const response = await axios.post(`${API_URL}api/asi/blockHFormSaveToDB`, newObject, config);
      const { status, message } = response.data;
      if (status) {
        blockValidation();
        try {
          const refreshPayload = {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear
          };
          const refreshRes = await axios.post(`${API_URL}api/asi/blockHForm`, refreshPayload, config);
          const rd = refreshRes.data?.data;
          if (refreshRes.data?.status && rd?.blockHData) {
            const sorted = [...rd.blockHData].sort((a, b) => {
              const indexA = itemCodeArray.indexOf(a.itemCode);
              const indexB = itemCodeArray.indexOf(b.itemCode);
              return indexA - indexB;
            });
            let numofblankrow = 24 - sorted.length;
            const merged = addNineEmptyRow(sorted, 'dynamic', numofblankrow - 1);
            const sf = pickBlockHStatusFlag(merged);
            setstatusFlageval(String(sf ?? '').trim());
            const nextBtn = await validateButtonASIBlock(decode_token, sf);
            setButtonStatus(nextBtn);
          }
        } catch (e) {
          console.error(e);
        }
        toast.success(message, messages.COLOR_RED);
        return true;
      }
    } catch (error) {
      console.error(error);
      toast.error('An error occurred while processing your request.', messages.COLOR_RED);
    } finally {
      showAppLoading(false);
    }
    return false;
  }


  const valForBlockH = () => {

    let allObjectData = itemData

    let dtable = dtableRef.current;
    let rowCount = dtable.rows.length;
    let softResult = "";
    const statusUnitCode = localStorage.getItem('statusUnitCode');
    const surveyYear = blockInfo.surveyYear;
    let nilai = 0;
    let purchase = 0;
    let basictot = 0;
    let nonbasictot = 0;
    let result = "";
    let arval = ["Quantity Consumed", "Purchase Value(in Rs)", "Rate Per Unit(in Rs)"];
    //debugger;
    
    // First, check specifically for rows 1-10 (i = 2 to 11, where i-1 gives serial number 1-10)
    // i=2 corresponds to serial number 1, i=3 to serial number 2, ..., i=11 to serial number 10
    const maxRowForCheck = Math.min(11, rowCount - 1);
    for (let i = 2; i <= maxRowForCheck; i++) {
      const row = dtable.rows[i];
      if (!row || !row.cells || !row.cells[2] || !row.cells[2].childNodes || !row.cells[2].childNodes[0]) {
        continue;
      }
      const itemCode = row.cells[2].childNodes[0].value || "";
      const qtyConsumed = (row.cells[4] && row.cells[4].childNodes && row.cells[4].childNodes[0]) ? row.cells[4].childNodes[0].value || "" : "";
      const purchaseValue = (row.cells[5] && row.cells[5].childNodes && row.cells[5].childNodes[0]) ? row.cells[5].childNodes[0].value || "" : "";
      const ratePerUnit = (row.cells[6] && row.cells[6].childNodes && row.cells[6].childNodes[0]) ? row.cells[6].childNodes[0].value || "" : "";
      const serialNumber = i - 1;
      
      // Check if Item Code is empty but any other column has value
      if ((itemCode === "" || itemCode === null || itemCode === undefined || itemCode.trim() === "") && 
          ((qtyConsumed !== "" && qtyConsumed !== null && qtyConsumed.trim() !== "") || 
           (purchaseValue !== "" && purchaseValue !== null && purchaseValue.trim() !== "") || 
           (ratePerUnit !== "" && ratePerUnit !== null && ratePerUnit.trim() !== ""))) {
        result += `SI.No ${serialNumber} should contain Item Code(NPCMS)\n`;
        if (row.cells[2]) {
          row.cells[2].style.backgroundColor = '#FF0000';
        }
      } else if (itemCode !== "" && itemCode !== null && itemCode !== undefined && itemCode.trim() !== "") {
        if (row.cells[2]) {
          row.cells[2].style.backgroundColor = '#FFFFFF';
        }
      }
    }
    
    for (let i = 2; i < rowCount - 1; i++) {
      const row = dtable.rows[i];

      for (let j = 4; j < 7; j++) {

        let node = row.cells[j].childNodes[0];

        if (j > 3 && node.value !== "" && node.value !== null) {

          if (row.cells[2].childNodes[0].value === "") {
            // For rows beyond 10, use the original message format
            if (i > 11) {
              result += `Sl no - ${i - 1} should contain ITEM CODE\n`;
            }
          }
          if (node.value.length > 15 && j !== 5) {
            result += `${arval[j - 4]} - ${i - 1} should be less than 15 digits \n`;
          }
          if (node.value.length > 12 && j === 5) {
            result += `${arval[j - 4]} - ${i - 1} should be less than 12 digits \n`;
          }
          if (isNaN(node.value)) {
            result += `${arval[j - 4]} - ${i - 1} should be a number\n`;
          }


          const yearArray = ["2017", "2018", "2019", "2020", "2021"];

          if (yearArray.includes(surveyYear) && !(statusUnitCode === '4' || statusUnitCode === '5' || statusUnitCode === '7' || statusUnitCode === '8')) {

            if ((i < (rowCount - 14) || i === (rowCount - 6) || i === (rowCount - 7) || i === (rowCount - 9)) && j === 5) {
              if (node.value !== "" && parseInt(node.value) > 0 && (row.cells[j - 1].childNodes[0].value === "" || parseInt(row.cells[j - 1].childNodes[0].value) === 0)) {
                result = result + "" + arval[0] + " or " + arval[1] + " - " + (i - 1) + " of the input item is zero \n";
                row.cells[j - 1].style.backgroundColor = '#FF0000';
              } else {
                row.cells[j - 1].style.backgroundColor = '#FFFFFF';
              }
            }
            if (i < (rowCount - 14) && j === 4) {
              if (node.value !== "" && parseInt(node.value) > 0 && (row.cells[j + 1].childNodes[0].value === "" || parseInt(row.cells[j + 1].childNodes[0].value) === 0)) {
                result = result + "" + arval[0] + " or " + arval[1] + " - " + (i - 1) + " of the input item is zero \n";
                row.cells[j + 1].style.backgroundColor = '#FF0000';
              } else {
                row.cells[j + 1].style.backgroundColor = '#FFFFFF';
              }
            }
            if ((i < (rowCount - 14) || i === (rowCount - 9)) && j === 6) {

              if ((row.cells[j - 2].childNodes[0].value !== "" && parseFloat(row.cells[j - 2].childNodes[0].value) !== 0) && (row.cells[j - 1].childNodes[0].value !== "" && parseFloat(row.cells[j - 1].childNodes[0].value) !== 0)) {
                if ((row.cells[j].childNodes[0].value === "" || parseFloat(row.cells[j].childNodes[0].value) === 0)) {
                  result = result + "" + arval[2] + " - " + (i - 1) + "  of the input item is zero \n";
                  row.cells[j].style.backgroundColor = '#FF0000';
                } else {
                  row.cells[j].style.backgroundColor = '#FFFFFF';
                }
              }
            }
            if (i === (rowCount - 14) && j === 5 && node.value !== "" && parseInt(node.value) > 0) {
              const nextrow = dtable.rows[i + 1];
              const nextnodeVal = nextrow.cells[j].childNodes[0].value;
              if (nextnodeVal !== "" && parseInt(nextnodeVal) > 0) {
                if (parseInt(node.value) > (0.15 * parseInt(nextnodeVal))) {
                  softResult = softResult + "" + "Other basic items is proportionately high \n";
                  row.cells[j].style.backgroundColor = '#ffaa00';
                } else {
                  row.cells[j].style.backgroundColor = '#FFFFFF';
                }
              }
            }

            //Item: Coal Consumed
            if (i === (rowCount - 7) && j === 5 && node.value !== "" && parseInt(node.value) > 0 && row.cells[j - 1].childNodes[0].value !== "" && parseInt(row.cells[j - 1].childNodes[0].value) > 0) {
              const val = parseInt(node.value) / parseInt(row.cells[j - 1].childNodes[0].value);
              if ((parseInt(val) < 1000) || (parseInt(val) > 50000)) {
                softResult = softResult + "" + "Rate of Coal consumed (Bl H Item 18) is abnormal \n";
                row.cells[j].style.backgroundColor = '#ffaa00';
              } else {
                row.cells[j].style.backgroundColor = '#FFFFFF';
              }
            }

            //Item: Electricity purchased & consumed
            if (i === (rowCount - 9) && j === 5 && node.value !== "" && parseInt(node.value) > 0 && row.cells[j - 1].childNodes[0].value !== "" && parseInt(row.cells[j - 1].childNodes[0].value) > 0) {
              const val = parseInt(node.value) / parseInt(row.cells[j - 1].childNodes[0].value);
              if ((parseInt(val) < 2) || (parseInt(val) > 25)) {
                softResult = softResult + "" + "Rate of Electricity purchased and consumed (Bl H Item 16) is abnormal. \n";
                row.cells[j].style.backgroundColor = '#ffaa00';
              } else {
                row.cells[j].style.backgroundColor = '#FFFFFF';
              }
            }

            //All items except 11,12,13,14,15,17,20,21,22,23,24.
            if (i < (rowCount - 14) && j === 5 && node.value !== "" && parseInt(node.value) > 0 && row.cells[j - 1].childNodes[0].value !== "" && parseInt(row.cells[j - 1].childNodes[0].value) > 0) {
              if (parseInt(node.value) < parseInt(row.cells[j - 1].childNodes[0].value)) {
                result = result + "" + arval[0] + " - " + (i - 1) + " is equal or greater than " + arval[1] + " \n";
                row.cells[j].style.backgroundColor = '#FF0000';
              } else {
                row.cells[j].style.backgroundColor = '#FFFFFF';
              }
            }
          }
        } else {
          if (((i < (rowCount - 14)) || i === (rowCount - 9)) && j === 6) {
            if ((row.cells[j - 2].childNodes[0].value !== "" && parseFloat(row.cells[j - 2].childNodes[0].value) !== 0) && (row.cells[j - 1].childNodes[0].value !== "" && parseFloat(row.cells[j - 1].childNodes[0].value) !== 0)) {
              if ((row.cells[j].childNodes[0].value === undefined || row.cells[j].childNodes[0].value === "" || parseFloat(row.cells[j].childNodes[0].value) === 0)) {
                result = result + "" + arval[2] + " - " + (i - 1) + "  of the input item is zero \n";
                row.cells[j].style.backgroundColor = '#FF0000';
              } else {
                row.cells[j].style.backgroundColor = '#FFFFFF';
              }
            }
          }
        }

        if (j === 5) {

          if (row.cells[2].childNodes[0].value === "9990100" && row.cells[2].childNodes[0].value !== "9992000" && nilai === 0) {
            nilai = 1;
            basictot = purchase;
            purchase = 0;

            var val1 = parseInt(basictot);
            var val2 = parseInt(row.cells[5].childNodes[0].value);

            if (val1 === val2) {
              row.cells[5].style.backgroundColor = '#FFFFFF';
            } else {
              result = result + "Total Baisc items - Please check total value \n";
              row.cells[5].style.backgroundColor = '#FF0000';
            }
          } else if (row.cells[5].childNodes[0].value !== "" && nilai === 0 && row.cells[2].childNodes[0].value !== "9990100" && row.cells[2].childNodes[0].value !== "9992000") {
            purchase = parseInt(purchase) + parseInt(row.cells[5].childNodes[0].value);
          } else if (row.cells[2].childNodes[0].value === "9992000" && row.cells[2].childNodes[0].value !== "9990100" && nilai === 1) {
            nilai = 2;
            nonbasictot = purchase;
            purchase = 0;
            if (parseInt(nonbasictot) !== parseInt(row.cells[5].childNodes[0].value) && row.cells[5].childNodes[0].value !== "") {
              result = result + "Total non-Baisc items - Please check total value\n";
              row.cells[5].style.backgroundColor = '#FF0000';
            } else {
              row.cells[5].style.backgroundColor = '#FFFFFF';
            }
          } else if (row.cells[5].childNodes[0].value !== "" && nilai === 1 && row.cells[2].childNodes[0].value !== "9990100" && row.cells[2].childNodes[0].value !== "9992000") {
            purchase = parseInt(purchase) + parseInt(row.cells[5].childNodes[0].value);
          }


          if (nilai === 2 && row.cells[2].childNodes[0].value === "9993000" && row.cells[2].childNodes[0].value !== "9990100") {
            purchase = basictot + nonbasictot;
            if (parseInt(purchase) !== parseInt(row.cells[5].childNodes[0].value) && row.cells[5].childNodes[0].value !== "") {
              result = result + "Total input - Please check total value\n\n";
              row.cells[5].style.backgroundColor = '#FF0000';
            } else {
              row.cells[5].style.backgroundColor = '#FFFFFF';
            }
          }
        }

        // Rate per Unit validation: Check if entered rate matches Purchase Value / Quantity Consumed
        for (let i = 2; i < rowCount - 1; i++) {
          const row = dtable.rows[i];
          const purchaseValue = parseFloat(row.cells[5].childNodes[0].value) || 0; // Column 6 (Purchase Value)
          const qtyConsumed = parseFloat(row.cells[4].childNodes[0].value) || 0; // Column 5 (Quantity Consumed)
          const ratePerUnit = parseFloat(row.cells[6].childNodes[0].value) || 0; // Column 7 (Rate per Unit)

          if (ratePerUnit > 0 && qtyConsumed > 0 && purchaseValue > 0) {
            const calculatedRatePerUnit = purchaseValue / qtyConsumed;
            const rateDifference = Math.abs(ratePerUnit - calculatedRatePerUnit);
            const tolerance = 0.01; // Allow small difference for rounding errors

            if (rateDifference > tolerance) {
              result = result + `Rate per Unit - ${i - 1} should be ${calculatedRatePerUnit.toFixed(2)} (${purchaseValue} ÷ ${qtyConsumed}) \n`;
              row.cells[6].style.backgroundColor = '#FF0000';
            } else {
              row.cells[6].style.backgroundColor = '#FFFFFF';
            }
          }
        }
      }
    }
    
    // Item 16: Electricity purchased & consumed - Quantity Consumed mandatory only if Purchase Value has value
    // If Purchase Value has value, then Quantity Consumed becomes mandatory
    // If Purchase Value is empty, user can bypass this item (Quantity Consumed can be empty)
    const item16RowIndex = rowCount - 9;
    if (item16RowIndex >= 2 && item16RowIndex < rowCount - 1) {
      const item16Row = dtable.rows[item16RowIndex];
      if (item16Row && item16Row.cells && item16Row.cells[5] && item16Row.cells[5].childNodes && item16Row.cells[5].childNodes[0]) {
        // Check Purchase Value (Column 6)
        const purchaseValue = item16Row.cells[5].childNodes[0].value || "";
        const purchaseValueNum = parseFloat(purchaseValue) || 0;
        
        // If Purchase Value has a value, then Quantity Consumed becomes mandatory
        if (purchaseValue !== "" && purchaseValue !== null && purchaseValue !== undefined && purchaseValue.trim() !== "" && purchaseValueNum > 0) {
          // Purchase Value has value, so check Quantity Consumed
          if (item16Row.cells[4] && item16Row.cells[4].childNodes && item16Row.cells[4].childNodes[0]) {
            const qtyConsumed = item16Row.cells[4].childNodes[0].value || "";
            const qtyConsumedNum = parseFloat(qtyConsumed) || 0;
            
            if (qtyConsumed === "" || qtyConsumed === null || qtyConsumed === undefined || qtyConsumed.trim() === "" || qtyConsumedNum === 0) {
              toast.error("Please enter Quantity consumed for Electricity purchased & consumed", messages.COLOR_RED);
              if (item16Row.cells[4]) {
                item16Row.cells[4].style.backgroundColor = '#FF0000';
              }
              return false;
            } else {
              if (item16Row.cells[4]) {
                item16Row.cells[4].style.backgroundColor = '#FFFFFF';
              }
            }
          }
        } else {
          // Purchase Value is empty, so Quantity Consumed is not mandatory (user can bypass)
          if (item16Row.cells[4]) {
            item16Row.cells[4].style.backgroundColor = '#FFFFFF';
          }
        }
      }
    }
    
    if (softResult !== "" && result === "") {

      softResult = softResult + " \nFor change any Values Click OK.";
      const clicked = window.confirm(softResult);
      softResult = "";
      if (clicked) {
        return false;
      } else {
        return true;
      }

    }
    if (result !== "") {
      result = softResult + " \n" + result;
      alert(result);
      return false;
    }

    return true
  }



  const storedLanguage = localStorage.getItem('language');

  return (
    <div className="card-body">
      {/* <ToastContainer/> */}
      <h4 className="page_heading border-bottom-0">
        <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_H_TITLE : asiTitle.en.BLOCK_H_TITLE }} />
      </h4>
      <div className="row">
        <div className="col-12">
          <h6 className="fw-semibold">
            {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
            {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
          </h6>
          <div className="table-responsive  asi_block_table">
            <table cellPadding="0" cellSpacing="0" className="table table-bordered block_c_table" id="velblockh" ref={dtableRef}>
              <thead>
                <tr>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEM_dESCRIPTION : asiTitle.en.ITEM_dESCRIPTION}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.ITEM_CODE : asiTitle.en.ITEM_CODE}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.UNIT_OF_QUANTITY : asiTitle.en.UNIT_OF_QUANTITY}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.QUANTITY_CONSUMED : asiTitle.en.QUANTITY_CONSUMED}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.PURCHASE_VALUE : asiTitle.en.PURCHASE_VALUE}</th>
                  <th>{storedLanguage === 'hi' ? asiTitle.hi.RATE_PER_UNIT : asiTitle.en.RATE_PER_UNIT}</th>
                </tr>
                <tr>
                  <th>1</th>
                  <th>2</th>
                  <th>3</th>
                  <th>4</th>
                  <th>5</th>
                  <th>6</th>
                  <th>7</th>
                </tr>
              </thead>

              <tbody>

                {Object.values(itemData).map((item, i) => {

                  let isIndex = false;
                  let isDisable = false;
                  const totalItems = Object.values(itemData).length;
                  const staticRowsStart = totalItems - 14;
                  
                  if (i >= staticRowsStart) {
                    isIndex = true;
                  }

                  if (itemCodeArray.includes(itemData[item.id].itemCode) &&
                    i >= staticRowsStart) {
                    isDisable = true
                  }

                  // Calculate serial number properly to avoid duplicates
                  // Continuous numbering: 1, 2, 3, ..., 10, 11, 12, ... (no gap at row 10)
                  let serialNumber = i + 1;

                  return (<tr key={i}>
                    <td>{serialNumber}
                      {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].includes(i) && isIndex === false &&
                        <>-
                          <input
                            type="checkbox"
                            id={`checkbox-${i}-id`}
                            checked={checkedItems.includes(i)}
                            onChange={(event) => handleCheckboxChange(event, i)} />
                        </>
                      }

                    </td>

                    <td>
                      <input
                        type="text"
                        className={`form-control ${['9990100', '9992000', '9993000'].includes(itemData[item.id].itemCode) ? 'text-bold-inside-textbox' : ''}`}
                        value={itemData[item.id].itemDesc}
                        id={`itemDesc${i}`}
                        name={`itemDesc${i}`}
                        disabled
                      />
                    </td>
                    <td className={`${itemData[item.id].itemCodeClass}`}>

                      <input
                        type="text"
                        className="form-control"
                        value={itemData[item.id].itemCode}
                        id={`itemCode${i}`}
                        name={`itemCode${i}`}
                        disabled={isDisable}
                        maxLength="7"
                        onChange={e => handleOnChange(item.id, 'itemCode', e.target.value)}
                        onFocus={e => handleOnFocus(item.id, 'itemCode')}
                        onBlur={e => handleOnBlur(item.id, e.target.value)}
                      />
                    </td>
                    <td>

                      {['9990400', '9990500', '9999900'].includes(itemData[item.id].itemCode) ?

                        "KWH"
                        :
                        <input
                          type="text"
                          className="form-control"
                          value={itemData[item.id].unitOfQty}
                          id={`unitOfQty${i}`}
                          name={`unitOfQty${i}`}
                          maxLength="19"
                          disabled={['9920100', '9920300', '9920400', '9922000', '9990100'
                            , '9990600', '9990700', '9990800', '9990900', '9992000', '9993000',
                            '9999900'].includes(itemData[item.id].itemCode)
                          }
                        />

                      }

                    </td>
                    <td>

                      <input
                        type="text"
                        className="form-control"
                        value={itemData[item.id].qtyConsumed}
                        id={`qtyConsumed${i}`}
                        name={`qtyConsumed${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'qtyConsumed', e.target.value)}
                        disabled={['9920100', '9920300', '9922000', '9990100'
                          , '9990400', '9990600', '9990800', '9992000', '9993000'].includes(itemData[item.id].itemCode)}
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={itemData[item.id].purchaseValue}
                        id={`purchaseValue${i}`}
                        name={`purchaseValue${i}`}
                        maxLength="12"
                        onChange={e => handleOnChange(item.id, 'purchaseValue', e.target.value)}
                        disabled={['9990400', '9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                    <td>
                      <input
                        type="text"
                        className="form-control"
                        value={itemData[item.id].ratePerUnit}
                        id={`ratePerUnit${i}`}
                        name={`ratePerUnit${i}`}
                        maxLength="18"
                        onChange={e => handleOnChange(item.id, 'ratePerUnit', e.target.value)}
                        disabled={['9920100', '9920300', '9920400', '9922000', '9990100'
                          , '9990400', '9990600', '9990700', '9990800', '9990900', '9992000', '9993000',
                          '9999900'].includes(itemData[item.id].itemCode)
                        }
                      />
                    </td>
                  </tr>)


                })}


              </tbody>
            </table>
          </div>
        </div>

      </div>
      <div className="row">
        <div className="col-12">
          <hr />
        </div>
        <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
          <button
            type="submit"
            className="btn btn_orange me-1"
            onClick={() => { window.print() }}
          >
            Print
            <i className="fa fa-print ms-1"></i>
          </button>

          <button
            type="button"
            className="btn btn_orange me-1"
            onClick={(e) => { handleSaveData("SAVE") }}
            disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
            id="save"
          >
            Save
          </button>

          <button
            type="reset"
            className="btn btn_orange me-1"
            onClick={handleReset}
          >
            Reset
          </button>

          <button
            type="button"
            className="btn btn_orange me-1"
            onClick={(e) => (navigate("/dashboard"))}
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-success me-1 px-3"
            onClick={addRow}
          >
            <i className="fa fa-plus-circle me-1"></i>
            Add Row
          </button>

          <button
            type="button"
            className="btn btn_red px-3"
            onClick={DeleteRow}
          >
            <i className="fa fa-minus-circle me-1"></i>
            Delete Row
          </button>
        </div>
        <div className="col-lg-4 text-center text-lg-end">
          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handlePrevious}
          >
            <i className="fa fa-angle-left me-1"></i>
            Previous
          </button>

          <button
            type="button"
            className="btn btn_orange mx-1"
            onClick={handleNext}
            disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
          >
            Next
            <i className="fa fa-angle-right ms-1"></i>
          </button>

        </div>
      </div>
    </div>
  )
}
